webpackJsonp([36530248567819],{

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = exports.TagList = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _kebabCase = __webpack_require__(232);
	
	var _kebabCase2 = _interopRequireDefault(_kebabCase);
	
	var _reactHelmet = __webpack_require__(93);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(23);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(8);
	
	var _animateComponents = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TagList = exports.TagList = _styledComponents2.default.ul.withConfig({
	  displayName: "tags__TagList"
	})(["list-style-type:none;margin-left:0;padding-left:0;"]);
	
	var TagsPage = function TagsPage(_ref) {
	  var _ref$data = _ref.data,
	      group = _ref$data.allPostsMarkdown.group,
	      title = _ref$data.site.siteMetadata.title;
	  return _react2.default.createElement(
	    _rebass.Box,
	    { py: 4 },
	    _react2.default.createElement(
	      _rebass.Container,
	      { pt: 4 },
	      _react2.default.createElement(
	        _animateComponents.FadeIn,
	        null,
	        _react2.default.createElement(_reactHelmet2.default, { title: title }),
	        _react2.default.createElement(
	          _rebass.Row,
	          { mx: 0, pb: 3 },
	          _react2.default.createElement(
	            _rebass.Heading,
	            null,
	            "all tags"
	          )
	        ),
	        _react2.default.createElement(
	          TagList,
	          null,
	          group.map(function (tag) {
	            return _react2.default.createElement(
	              _rebass.Row,
	              { key: tag.fieldValue, mx: 0, pb: 2 },
	              _react2.default.createElement(
	                _rebass.Subhead,
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: "/tags/" + (0, _kebabCase2.default)(tag.fieldValue) + "/" },
	                  tag.fieldValue
	                )
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	TagsPage.propTypes = {
	  data: _propTypes2.default.shape({
	    allPosts: _propTypes2.default.shape({
	      group: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        fieldValue: _propTypes2.default.string.isRequired
	      }).isRequired)
	    }),
	    site: _propTypes2.default.shape({
	      siteMetadata: _propTypes2.default.shape({
	        title: _propTypes2.default.string.isRequired
	      })
	    })
	  })
	};
	
	exports.default = TagsPage;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tags-jsx-06b66e5fed71b81185ec.js